import React from "react";
import { Link } from "react-router-dom";

const COLS = [
  {
    title: "Product",
    links: [
      ["Time tracking", "/features"],
      ["Project budgets", "/features"],
      ["Invoicing", "/features"],
      ["Integrations", "/features"],
      ["Pricing", "/pricing"],
    ],
  },
  {
    title: "Compare",
    links: [
      ["All comparisons", "/compare"],
      ["vs Harvest", "/compare/harvest"],
      ["vs Toggl Track", "/compare/toggl-track"],
      ["vs Clockify", "/compare/clockify"],
      ["vs FreshBooks", "/compare/freshbooks"],
    ],
  },
  {
    title: "Company",
    links: [
      ["Customers", "/customers"],
      ["About The Bench", "https://www.thebench.au"],
      ["Contact", "/"],
      ["Careers", "/"],
    ],
  },
  {
    title: "Support",
    links: [
      ["Help centre", "/"],
      ["API docs", "/"],
      ["System status", "/"],
      ["Privacy", "/"],
      ["Terms", "/"],
    ],
  },
];

export default function Footer() {
  return (
    <footer className="bg-forest text-white mt-24">
      <div className="max-w-7xl mx-auto px-5 md:px-8 py-16 grid grid-cols-2 md:grid-cols-6 gap-8">
        <div className="col-span-2">
          <div className="flex items-center gap-2">
            <img className="logo-b" src="/logo-b.png" alt="Full Bench" />
            <span className="font-display text-2xl">Full Bench</span>
          </div>
          <p className="mt-4 text-sm text-white/70 max-w-xs">
            Plan, manage and monitor projects. Bill for every hour. Built for consulting professionals who charge on time and expense.
          </p>
          <p className="mt-4 text-xs text-white/60">A product by <a href="https://www.thebench.au" className="underline hover:text-white">The Bench</a></p>
          <p className="mt-3 text-xs text-white/50">Level 19, 324 Queen Street, Brisbane QLD 4000</p>
          <p className="text-xs text-white/50">hello@thebench.au</p>
        </div>
        {COLS.map((c) => (
          <div key={c.title}>
            <div className="text-sm font-semibold mb-3">{c.title}</div>
            <ul className="space-y-2 text-sm text-white/75">
              {c.links.map(([label, href]) => {
                const external = href.startsWith("http");
                return (
                  <li key={label}>
                    {external ? (
                      <a href={href} target="_blank" rel="noreferrer" className="hover:text-white">{label}</a>
                    ) : (
                      <Link to={href} className="hover:text-white">{label}</Link>
                    )}
                  </li>
                );
              })}
            </ul>
          </div>
        ))}
      </div>
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-5 md:px-8 py-6 text-xs text-white/60 flex flex-col md:flex-row justify-between gap-3">
          <div>© {new Date().getFullYear()} Full Bench, by The Bench. All rights reserved.</div>
          <div>Made in Brisbane.</div>
        </div>
      </div>
    </footer>
  );
}
